// extracted by mini-css-extract-plugin
export default {"btn":"couponsManagement_btn__cwDcv"};